<template>

    <div class="col-span-6 text-sm">


        <div class="flex flex-row flex-grow">
            <div class="flex flex-grow items-center gap-x-1">
                <div class="flex font-medium flex-1">Account name:</div>
                <div class="flex flex-1 justify-end">
                    <input type="text" ref="team_name_field" v-model="form.name" @input="changedTeamName"
                        class="text-left w-full inline py-2 mt-0 px-3 border-0 border-gray-200 focus:ring-0 focus:border-blue-500 font-bold bg-gray-100 focus:bg-blue-50 text-birdie-blue focus:text-blue-600 rounded-lg text-sm" />
                </div>
            </div>

        </div>

        <jet-section-border />

        <div class="flex items-start gap-x-8">

            <div class="flex flex-col flex-grow gap-y-3 pt-2">
                <span class="font-medium">Account logo</span>
                <list-toggle>
                    <template #title>
                        <span class="text-sm text-right">Requirements for your Logo</span>
                    </template>
                    <template #content>
                        <div class="text-sm">
                            <p class="">The file should be in <strong>JPG, SVG, PNG, or GIF</strong> format.</p>
                            <p class="pt-2">The file size should not be larger than <strong>4 MB.</strong></p>
                            <p class="pt-2">For best results, select a square image with a minimum dimension of 300
                                pixels or more.</p>
                        </div>
                    </template>
                </list-toggle>
            </div>

            <div class="flex flex-shrink ">

                <!-- <div v-if="team_logo_url != ''" class="flex logoUpload relative">

                    <label
                        class="upload-button z-1 " :style="'background-image:url('+team_logo_url+')'">
                    </label>

                    <a href="#"
                        class="absolute w-full h-full flex flex-col justify-center items-center bg-white bg-opacity-70 opacity-0 hover:opacity-100"
                        @click.prevent="deleteLogo()" v-tippy="{content:'Delete your logo'}">
                        <XCircleIcon class="h-12 w-12 text-red-600" />
                    </a>
                </div>

                <DropZone v-else
                    :fileSizeMaxInMb="4"
                    :meta="{}"
                    :extensions="['png','jpg','gif','svg']"
                    path="parameters"
                    @file-added="fileAdded"
                    @file-removed="fileRemoved">

                    <template v-slot:icon="slotProps">

                        <svg class="mx-auto h-12 w-12"
                            :class="{'text-gray-400':!slotProps.dragging, 'text-indigo-600':slotProps.dragging}"
                            fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                        </svg>

                    </template>

                </DropZone> -->

                <div v-if="true" class="flex logoUpload relative">

                    <label for="upload-logo" class="upload-button z-1 "
                        :class="{ 'empty border-2 border-gray-500 border-dashed': team_logo_url == '' }"
                        id="upload-button" title="Select an image for your Logo"
                        :style="'background-image:url(' + team_logo_url + ')'">
                        <div>Upload</div>
                    </label>

                    <a href="#" v-if="team_logo_url != ''"
                        class="absolute w-full h-full flex flex-col justify-center items-center bg-white bg-opacity-70 opacity-0 hover:opacity-100"
                        @click.prevent="deleteLogo()" v-tippy="{ content: 'Delete your logo' }">
                        <XCircleIcon class="h-12 w-12 text-red-600" />
                    </a>

                    <input v-else class="absolute opacity-0 z-0 w-0 h-0" type="file" name="logo" id="upload-logo"
                        ref="photo" @change="upload_logo()" />

                    <div v-if="is_uploading"
                        class="absolute w-full h-full flex flex-col justify-center items-center bg-gray-700 rounded-md">
                        <spinner class="h-8 w-8 text-white"></spinner>
                    </div>
                </div>
            </div>


            <div class="logoUpload flex w-full max-w-xl mx-auto" v-if="is_uploading && false">
                <div class="upload-info my-1 ml-4 flex flex-row flex-grow">
                    <span>Sending image…</span>
                </div>
            </div>


        </div>

        <jet-section-border />

        <div class="flex justify-between ">

            <div class="flex flex-col items-start ">
                <div class="font-medium flex items-center gap-x-2">Remove Birdie branding
                    <UpgradePlan v-if="!canToggleFooter" />
                </div>
            </div>

            <div class="flex flex-row justify-center text-gray-600">
                <toggle :checked="hide_zest_footer && canToggleFooter" :disabled="!canToggleFooter" @click.prevent.stop
                    @update="toggleHideFooter"></toggle>
            </div>

        </div>


    </div>



</template>






<script>

import Spinner from '@/Components/UI/Spinner'
import ColorUtil from "@/tools.js"
import ListToggle from '@/Components/UI/ListToggle'
import JetSectionBorder from '@/Jetstream/SectionBorder'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import Toggle from '@/Components/UI/Toggle'
import UpgradePlan from '@/Components/UI/UpgradePlan.vue'
import { XCircleIcon } from "@heroicons/vue/20/solid"
//import DropZone from '@/Components/UI/DropZone'
// const CancelToken = axios.CancelToken;
// let cancel;

export default {

    props: ['w_settings', 'can_remove_branding'],

    components: {
        Spinner, ListToggle, JetSectionBorder, JetSecondaryButton,
        Toggle, UpgradePlan, XCircleIcon, //DropZone
    },

    data() {
        return {
            is_modal: false,

            widget_settings: this.w_settings,
            is_uploading: false,
            form: this.$inertia.form({
                _method: 'PUT',
                name: this.$page.props.user.current_team.name,
                photo: null,
                deletephoto: null
            }),
            onboard_customize: false,
            timeout: Object,
            buffer: 600,
            lastTypeMoment: 0,
            saving: false,
            canToggleFooter: this.can_remove_branding, // this.$page.props.isz || this.$page.props.subscribed,
            app_name: this.$page.props.app_name,
            current_team: this.$page.props.user.current_team
        }
    },

    created() {

        if (this.team_logo_url.includes("https://ui-avatars.com/api/")) {
            this.team_logo_url = ""
        }
    },
    computed: {
        team_field_size() {
            if (this.form.name.length >= 12) {
                return Math.round(this.form.name.length * 0.9) - 2
            }
            return Math.round(this.form.name.length * 0.9) - 1
        },
        active_custom() {
            //var ok = true;
            for (const color in this.preset) {
                if (this.widget_settings.color == this.preset[color]) {
                    return false
                }
            }
            return true
        },
        is_light() {
            return ColorUtil.lightOrDark(this.widget_settings.color) == "light"
        },
        hide_zest_footer() {
            if (this.widget_settings.hide_zest_footer) {
                return this.widget_settings.hide_zest_footer == 'yes'
            }
            return false
        },
        customer_can_add_comment() {
            if (this.widget_settings.customer_can_add_comment) {
                return this.widget_settings.customer_can_add_comment == 'yes'
            }
            return false
        },
        team_logo_url() {
            if (this.current_team.team_logo_url.startsWith('https://ui-avatars.com/api')) {
                return ""
            }
            return this.current_team.team_logo_url
        }
    },
    mounted() {
    },
    methods: {
        changedTeamName() {
            if (this.form.name.length > 2) {
                let now = new Date().getTime();
                if (now - this.lastTypeMoment < this.buffer) {
                    clearTimeout(this.timeout);
                }
                if (this.saving) {
                    // this.cancel();
                }
                this.timeout = setTimeout(function () { this.saveTeamName() }.bind(this), this.buffer);
                this.lastTypeMoment = now;
            } else {
                clearTimeout(this.timeout);
            }
        },
        saveTeamName() {
            if (!this.$page.props.canManageSettings) {
                return
            }
            this.saving = true
            this.form.post(route('teams.update', this.current_team), {
                errorBag: 'updateTeamName',
                preserveScroll: true,
                onSuccess: () => {
                    this.name_success()
                    this.saving = false
                }
            });
        },
        name_success: function () {
            let options = {
                //type: "default",
                // toastBackgroundColor: "#FFFFFF",
                timeout: 6000,
                position: "top-right",
                // hideProgressBar: false,
            }
            this.$moshaToast("Account name updated!", options)
        },
        upload_success: function () {
            let options = {
                type: "default",
                timeout: 6000,
                position: "top-right",
                hideProgressBar: false,
            }
            this.$moshaToast("Your logo was updated!", options)
        },
        upload_error_type: function () {
            let options = {
                type: "danger",
                timeout: -1,
                position: "top-right",
            }
            this.$moshaToast("Your file must match any of these formats: png, jpg, gif, svg", options)
        },
        upload_error_size: function () {
            let options = {
                type: "danger",
                timeout: -1,
                position: "top-right",
            }
            this.$moshaToast("The file size is limited to 4 MB", options)
        },
        upload_error_none: function () {
            let options = {
                type: "danger",
                timeout: -1,
                position: "top-right",
            }
            this.$moshaToast("Error: no file selected…", options)
        },
        upload_error_misc: function () {
            let options = {
                type: "danger",
                timeout: -1,
                position: "top-right",
            }
            this.$moshaToast("Unknown error occurred, try to change your logo from your Team Settings page.", options)
        },

        deleteLogo() {
            if (!this.$page.props.canManageSettings) {
                return
            }
            //console.log("OOOOO")
            this.is_uploading = true
            this.form.deletephoto = "delete"
            this.form.post(route('teams.update', this.current_team), {
                errorBag: 'updateTeamName',
                preserveScroll: true,
                onSuccess: (data) => {
                    console.log(data.props.user.current_team)
                    this.clearPhotoFileInput()
                    this.upload_success()
                    this.is_uploading = false
                    this.current_team = data.props.user.current_team
                }
            });
        },

        upload_logo: function () {
            if (this.is_uploading) {
                return
            }
            if (!this.$page.props.canManageSettings) {
                return
            }

            // a-t-on un fichier ?
            if (this.$refs.photo) {
                this.form.photo = this.$refs.photo.files[0]
            } else {
                this.upload_error_none()
                return
            }

            // est-il de la bonne taille ?
            let max_filesize = 4; // 4 Mo
            if (this.form.photo.size > 1024 * 1024 * max_filesize) {
                this.upload_error_size()
                return;
            }

            // a-t-il la bonne extension ?
            let ext = this.form.photo.name.substr(this.form.photo.name.lastIndexOf('.') + 1).toLowerCase();
            var allow = ['png', 'jpeg', 'jpg', 'gif', 'svg'];
            if (allow.indexOf(ext) < 0) {
                this.upload_error_type();
                return;
            }

            delete this.form.deletephoto
            this.is_uploading = true

            this.form.post(route('teams.update', this.current_team), {
                errorBag: 'updateTeamName',
                preserveScroll: true,
                onSuccess: (data) => {
                    console.log(data.props.user.current_team)
                    this.clearPhotoFileInput()
                    this.upload_success()
                    this.is_uploading = false
                    this.current_team = data.props.user.current_team
                }
            });
        },
        clearPhotoFileInput() {
            if (this.$refs.photo?.value) {
                this.$refs.photo.value = null;
            }
        },

        toggleHideFooter() {
            if (!this.canToggleFooter) {
                return
            }
            if (!this.$page.props.canManageSettings) {
                return
            }

            let url = this.$page.props.api_url + '/v1/settings/appearance';

            // if (this.hide_zest_footer) {
            //     this.widget_settings.hide_zest_footer = "no"
            // } else {
            //     this.widget_settings.hide_zest_footer = "yes"
            // }
            var params = {
                hide_zest_footer: this.hide_zest_footer ? "no" : "yes",
            };
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    if (response.data) {
                        this.widget_settings = JSON.parse(response.data.settings)
                        let options = {
                            type: "default",
                            timeout: 2500,
                            position: "top-right",
                            hideProgressBar: false,
                        }
                        this.$moshaToast("Setting updated!", options)
                    }
                })
                .catch(e => {
                    console.error(e);
                });

            if (this.hide_zest_footer) {
                this.widget_settings.hide_zest_footer = "no"
            } else {
                this.widget_settings.hide_zest_footer = "yes"
            }
        },

    }

}

</script>

<style scoped>
label.upload-button {
    cursor: pointer;
    display: inline-block;
    font-size: .1%;
    text-indent: -9999px;
    background-repeat: no-repeat;
    background-position: 50%;
    background-color: #FFF;
    background-size: contain;
    width: 80px;
    height: 80px;
    border-radius: 3px;
    margin: 0;
}

label.upload-button.empty {
    background-color: rgb(229, 231, 235);
}

label.upload-button>div {
    width: 100%;
    height: 100%;
    border-radius: 3px;
    opacity: 0;
    background-repeat: no-repeat;
    background-position: 50%;
    background-color: #fff;
    background-image: url(/img/plus.svg);
    background-size: 40%;
    transition: opacity .2s ease-in-out;
}

label.upload-button:hover {
    border-style: solid;
}

label.upload-button:hover>div {
    opacity: .7;
}
</style>
